<template>
  <div class="main-menu">
    <div class="logo">
      <router-link to="/">
        <img src="/assets/marketpro-logo.svg" class="logo-dark" alt="Logo Marketpro" width="180" />
      </router-link>
    </div>
    <div class="nav">
      <v-list color="primary" dark>
        <v-list-item v-for="item in menuItems" :key="item.title" :to="item.url">
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      menuItems: [
        {
          title: "Mes services",
          icon: "mdi-cart",
          url: "/services/list"
        },
        {
          title: "Mon profil",
          icon: "mdi-account",
          url: "/profile"
        },
        {
          title: "Mes commandes",
          icon: "mdi-account-cash",
          url: "/orders/list"
        },
        {
          title: "Déconnexion",
          icon: "mdi-logout-variant",
          url: "/logout"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.main-menu {
  display: flex;
  flex-direction: column;
  .logo {
    flex: 0 0 200px;
    img {
      display: block;
      margin: 30px auto;
    }
  }
  .nav {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ul {
      li {
        a {
          color: white;
        }
      }
    }
  }
}
</style>